import type { LocaleCode } from "@homeinstead/locale";

import {
  getPostalCodeFormatErrorMessage,
  getPostalCodeRequiredErrorMessage,
  getPostalLocationRequiredErrorMessage,
} from "@homeinstead/locale";
import { isPostalCodeFormatValid } from "./is-postal-code-format-valid";

type PostalLocationValues = {
  location: string;
  postalCode: string;
};

/**
 * Errors for a postal code question whose values are incomplete or invalid:
 * - `postalCode` "required" when nothing is typed (`location` is empty).
 * - `postalCode` "format" when the typed value is not a valid postal code.
 * - `location` when a valid code is typed but no office is picked
 *   (`postalCode` is empty).
 */
function getPostalLocationValidationErrors(
  values: PostalLocationValues,
  localeCode: LocaleCode,
): Record<string, string[]> {
  const typedPostalCode = values.location.trim();

  if (typedPostalCode === "") {
    return { postalCode: [getPostalCodeRequiredErrorMessage(localeCode)] };
  }

  if (!isPostalCodeFormatValid(typedPostalCode, localeCode)) {
    return { postalCode: [getPostalCodeFormatErrorMessage(localeCode)] };
  }

  if (values.postalCode.trim() === "") {
    return { location: [getPostalLocationRequiredErrorMessage(localeCode)] };
  }

  return {};
}

export { getPostalLocationValidationErrors };
